export const SIGN_UP = 'sign up';
export const LOGIN = 'login';
export const CHECK = 'check';

// GET
export const GET_SITES = 'sites';
export const GET_INTERESTS = 'interests';
export const GET_SPECIMENS = 'specimens';
